import React from "react"
import PropTypes from "prop-types"
import Container from "../Container"
import FooterTop from "./FooterTop"
import FooterBottom from "./FooterBottom"

import { useI18next } from "gatsby-plugin-react-i18next"
import "./Footer.less"

// Temporary Data
import { SocialLinkData, OtherWebData } from "../../dummy/Global"

function Footer(props) {
  const { t } = useI18next()
  const FooterMenuData = [
    {
      text: t("Peta Situs"),
      url: "/peta-situs",
    },
    {
      text: t("Hubungi Kami"),
      url: "/informasi/hubungi-kami/",
    },
    {
      text: t("Prasyarat"),
      url: "/prasyarat",
    },
    {
      text: t("FAQ"),
      url: "https://bantuan.lpdp.kemenkeu.go.id/kb",
    },
  ]
  return (
    <footer className={`footer ${props.theme}`}>
      <div className="footer-top">
        <Container>
          <FooterTop footerMenu={FooterMenuData} />
        </Container>
      </div>
      <div className="footer-bottom">
        <FooterBottom socialLink={SocialLinkData} otherWebsite={OtherWebData} />
      </div>
    </footer>
  )
}

Footer.prototypes = {
  theme: PropTypes.oneOf(["cream", "blue"]),
}

Footer.defaultProps = {
  theme: "cream",
}

export default Footer

